/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

window.onload = function() {
    setTimeout(close_drawer, 1000);
    setTimeout(close_drawer, 3000);
};

function close_drawer() {
  const drawer = document.getElementsByClassName("Drawer");
  for (let i = 0; i < drawer.length; i++) {
    drawer[i].setAttribute("aria-hidden", "true");
  }
  const search = document.getElementsByClassName("Search");
  for (let i = 0; i < search.length; i++) {
    search[i].setAttribute("aria-hidden", "true");
  }
  const dropdownMenu = document.getElementsByClassName("DropdownMenu");
  for (let i = 0; i < dropdownMenu.length; i++) {
    dropdownMenu[i].setAttribute("aria-hidden", "true");
  }

  const megaMenu = document.getElementsByClassName("MegaMenu");
  for (let i = 0; i < megaMenu.length; i++) {
    megaMenu[i].setAttribute("aria-hidden", "true");
  }
  
}
